import React, {useState, useEffect, useRef} from "react";
import {Validate} from "Framework/helpers/FormFieldHelper/FormFieldHelper";
import {ButtonText} from "BaseComponents/Button";
import {useGlobal} from "reactn";
import {Paragraph} from "BaseComponents/Text/";
import {Link as LoginLink} from "BaseComponents/Link";
import styled from "styled-components";

import {
    LoginErrorText,
    ErrorText,
    Link,
    ResetTextStyle,
    LabelWrapper,
    LoginButton,
    LoginInput,
    Label,
    Field,
    InputWrapper,
} from "./styles/loginStyles";

const ResponseMessage = styled.div`
  display: flex;
  background: ${({backgroundColor}) => backgroundColor};
  padding: 1.5rem 1rem;
  margin: 1rem 0;
  width: 100%;
`;

const ConfirmAndReset = ({Email, IsConfirmed, aft, Reset, ResetUserId, CurrentPageId}) => {
    const [emailValue, setEmail] = useState("");
    const [passwordValue, setPassword] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [passwordMissingError, setPasswordMissingError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState("");
    const [responseStatus, setResponseStatus] = useState(false);
    const [userIsConfirmed, setUserIsConfirmed] = useState(false);
    const [showLoginLink, setShowLoginLink] = useState(false);
    const [theme] = useGlobal("theme");

    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);

    useEffect(() => {
        setEmail(Email);
        setUserIsConfirmed(IsConfirmed || Reset);
    }, []);

    const onChange = (value, type, errorFunc) => errorFunc(Validate(value, type));

    const getHeaders = () => {
        let headers = {};
        headers["__RequestVerificationToken"] = aft;
        headers["RequestVerificationToken"] = aft;
        headers["Content-Type"] = "application/json";
        return headers;
    };

    const onSubmitClick = (e) => {
        e.preventDefault();
        setEmailError(false);
        setPasswordError(false);
        setPasswordMissingError(false);

        let password = passwordRef.current;
        let confirmPassword = confirmPasswordRef.current;
        let email = emailRef.current;

        let isError = false;
        let ignorePassword =
            !password.value.length && !confirmPassword.value.length;

        if (
            !ignorePassword &&
            (password.value != confirmPassword.value ||
                Validate(password, "password"))
        ) {
            setPasswordError(true);
            isError = true;
        }
        if (!userIsConfirmed) {
            if (Validate(password, "password")) {
                setPasswordMissingError(true);
                isError = true;
            }
            if (Validate(email, "email")) {
                setEmailError(true);
                isError = true;
            }
        }

        if (!isError) {
            setIsLoading(true);
            setStatusMessage("");
            let bodyJson = JSON.stringify({
                Username: email != null && !Reset ? email.value : null,
                Password: password.value,
                Email: email != null && !Reset ? email.value : null,
                ResetPassword: password.value.length > 0 && !Reset,
                Id: Reset ? ResetUserId : null,
                UserIsConfirmed: userIsConfirmed,
                CurrentPageId
            });
            var endpoint = !Reset ? "/user/confirm" : "/user/setPassword";
            fetch(endpoint, {
                method: "POST",
                headers: getHeaders(),
                body: bodyJson,
            })
                .then((response) => response.json())
                .then(
                    ({Status, Message, User}) => {
                        if (Status) {
                            if (Reset) {
                                setShowLoginLink(true);
                            } else {
                                setEmail(User.Email);
                                setUserIsConfirmed(true);
                            }
                        }
                        setStatusMessage(Message);
                        setIsLoading(false);
                        setResponseStatus(Status);
                    },
                    (error) => {
                        setIsLoading(false);
                    }
                );
        }
    };

    return (
        <>
            {statusMessage.length > 0 && (
                <>
                    <ResponseMessage
                        backgroundColor={
                            responseStatus ? "rgb(75 150 11)" : theme.colors.error
                        }
                    >
                        <Paragraph color={theme.colors.white}>{statusMessage}</Paragraph>
                    </ResponseMessage>
                    {showLoginLink && (
                        <Paragraph>
                            Gå till <LoginLink text="inloggningssidan" href="/logga-in"/>
                        </Paragraph>
                    )}
                </>
            )}
            <InputWrapper>
                {!userIsConfirmed && (
                    <Field>
                        <Label>Din privata e-postadress</Label>
                        <LoginInput
                            defaultValue={emailValue}
                            type="email"
                            ref={emailRef}
                            disabled={isLoading}
                            error={emailError}
                            aria-invalid={emailError}
                            onChange={(emailRef) =>
                                onChange(emailRef.currentTarget, "email", setEmailError)
                            }
                        />
                        {emailError && <ErrorText>Måste vara en giltig email</ErrorText>}
                    </Field>
                )}
                <Field>
                    <Label>Välj nytt lösenord</Label>
                    <LoginInput
                        disabled={isLoading}
                        type="password"
                        ref={passwordRef}
                        aria-invalid={passwordError}
                        error={passwordError || passwordMissingError}
                        onChange={(passwordRef) =>
                            onChange(
                                passwordRef.currentTarget,
                                "password",
                                setPasswordMissingError
                            )
                        }
                    />
                    {passwordMissingError && (
                        <ErrorText>Du måste välja ett nytt lösenord</ErrorText>
                    )}
                </Field>
                <Field>
                    <Label>Bekräfta nytt lösenord</Label>
                    <LoginInput
                        disabled={isLoading}
                        type="password"
                        ref={confirmPasswordRef}
                        aria-invalid={passwordError}
                        error={passwordError}
                    />
                    {passwordError && (
                        <ErrorText>Lösenorden måste matcha varandra</ErrorText>
                    )}
                </Field>

                <LoginButton
                    onClick={(e) => onSubmitClick(e)}
                    width="100%"
                    margin="3rem 0 0 0"
                    pageloading={isLoading}
                >
                    {!isLoading && <ButtonText forcedFontSize="24px">Spara</ButtonText>}
                </LoginButton>
            </InputWrapper>
        </>
    );
};

export default ConfirmAndReset;
